<template>
    <GestionBajas />
  </template>
  <script>
  import GestionBajas from "./components/GestionBajas.vue";
  export default {
    name: "BajasContables",
    components: { GestionBajas }
  };
  </script>